
import React from 'react';
// Remove unused imports for OAuth providers
// import { FcGoogle } from 'react-icons/fc';
// import { FaFacebook, FaApple, FaTwitter } from 'react-icons/fa';

interface OAuthLoginProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

const OAuthLogin: React.FC<OAuthLoginProps> = () => {
  return (
    <div className="w-full space-y-3">
      <div className="relative flex justify-center items-center">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-gray-300" />
        </div>
        <div className="relative px-4 text-sm bg-white text-gray-500">
          Email verification only
        </div>
      </div>
    </div>
  );
};

export default OAuthLogin;
